export const LANGS = ["ru", "uk", "en"];

export const LANG_LABEL = { ru: "RU", uk: "UA", en: "EN" };

export const dict = {
  uk: {
    nav_edu: "Навчання",
    nav_signals: "Signals",
    nav_scanner: "Scanner",
    nav_profile: "Профіль",
    nav_copytrade: "Копітрейдинг",
    nav_menu_open: "Відкрити меню",
    nav_menu_close: "Закрити меню",
    nav_status_online: "у мережі",

    reg_title: "Введи ID акаунта",
    reg_desc: "Якщо ID не знайдено, зареєструйтесь за посиланням і поповніть рахунок.",
    reg_register: "Зареєструватися",
    reg_have_account: "Вже є акаунт",
    reg_id_label: "ID акаунта",
    reg_id_hint: "Тільки цифри, наприклад 12345678",
    reg_id_hint_pocket: "Тільки цифри, наприклад 12345678",
    reg_id_placeholder: "Введи ID акаунта",
    reg_verify: "Перевірити ID",
    reg_error: "ID не знайдено. Перевірте і спробуйте ще раз.",
    reg_support: "Звернутись у підтримку",
    reg_closed_title: "Реєстрація тимчасово вимкнена",
    reg_closed_desc: "Реєстрація зараз відключена. Слідкуйте за новинами або зверніться до підтримки.",
    reg_switch_title: "Вже є акаунт Pocket Option?",
    reg_switch_desc1: "Щоб потрапити в нашу команду, потрібно відобразитись в нашій системі. Для цього створіть новий акаунт строго за нашим посиланням.",
    reg_switch_desc2: "Якщо на старому акаунті є кошти, їх потрібно просто вивести.",
    reg_switch_desc3: "Торгувати ви будете вже з нового акаунта, створеного за нашим посиланням.",
    reg_switch_step1: "Вийди з поточного акаунта в Pocket Option.",
    reg_switch_step2: "Закрий усі вкладки з Pocket Option.",
    reg_switch_step3: "Перейди за нашим посиланням.",
    reg_switch_step4: "Зареєструй новий акаунт.",
    reg_switch_step5: "Пошту вводь вручну, а не через швидку реєстрацію.",
    reg_switch_note: "Зроби все строго по порядку.",
    reg_switch_link: "Перейти за посиланням",
    reg_link_alt_ru: "Посилання не відкривається? Спробуйте дзеркало для РФ",
    reg_link_alt_main: "Не з Росії? Відкрити основне посилання",
    reg_switch_back: "Назад",
    reg_test_code_link: "Використати тестовий код",
    reg_test_code_title: "Тестовий доступ",
    reg_test_code_desc: "Введи 6-значний код (літери та цифри), який ти отримав для тестування додатка.",
    reg_test_code_label: "Тестовий код",
    reg_test_code_placeholder: "Наприклад: A1B2C9",
    reg_test_code_hint: "6 символів: латинські літери та цифри",
    reg_test_code_verify: "Активувати код",
    reg_test_code_error: "Невірний або прострочений код. Перевір і спробуй ще раз.",
    reg_test_code_back: "Назад",
    reg_trial_link: "Пробний період",
    reg_trial_title: "Пробний період",
    reg_trial_desc: "Безкоштовний пробний період без коду: 5 сигналів на кожен таймфрейм.",
    reg_trial_verify: "Активувати пробний період",
    reg_trial_error: "Не вдалося активувати пробний період. Спробуй ще раз.",
    reg_trial_taken: "Пробний період для цього акаунту вже активовано раніше.",
    reg_trial_back: "Назад",
    auth_loading: "Перевіряємо акаунт…",
    auth_tab_login: "Вхід",
    auth_tab_signup: "Реєстрація",
    auth_login_title: "З поверненням",
    auth_login_desc: "Увійдіть за допомогою пошти та пароля.",
    auth_signup_title: "Створити акаунт",
    auth_signup_desc: "Вкажіть пошту, пароль та ID вашого акаунта Pocket Option.",
    auth_login_placeholder: "Електронна пошта",
    auth_password_placeholder: "Пароль",
    auth_fullname_placeholder: "Ім'я та прізвище (необов'язково)",
    auth_email_invalid: "Введіть коректну електронну пошту.",
    auth_error_not_found: "Невірна пошта або пароль.",
    auth_error_login_taken: "Ця пошта вже зареєстрована. Спробуйте увійти.",
    auth_error_password_short: "Пароль має містити щонайменше 8 символів.",
    auth_error_generic: "Щось пішло не так. Спробуйте ще раз.",
    auth_login_submit: "Увійти",
    auth_signup_submit: "Зареєструватися",

    edu_title: "Навчання трейдингу",
    edu_sub: "Курси від основ до практики",
    edu_continue: "Продовжити",
    edu_locked: "Закрито",
    course1_t: "Основи ринку",
    course1_d: "Свічки, тренд, підтримка/опір",
    course2_t: "Управління ризиком",
    course2_d: "Розмір угоди, стоп, депозит",
    course3_t: "Патерни розвороту",
    course3_d: "Формації для входу в угоду",
    edu_about: "Про курс",
    edu_program: "Програма курсу",
    edu_min: "хв.",
    edu_lesson_word: "уроки",
    edu_loading: "Завантаження курсів...",
    edu_error: "Не вдалося завантажити курси. Спробуйте ще раз.",
    edu_retry: "Спробувати ще раз",
    edu_empty: "Поки що немає доступних курсів.",
    edu_lesson_fallback: "Урок",
    edu_hour: "год",
    lesson_loading: "Завантаження уроку...",
    lesson_error: "Не вдалося завантажити урок. Спробуйте ще раз.",
    lesson_protected_hint: "Матеріал доступний лише для перегляду — без завантаження й копіювання",
    edu_video_title: "Відео уроку",
    lesson_devtools_warning: "Контент приховано, поки відкриті інструменти розробника",

    nav_live: "Live Charts",
    live_title: "Live Charts",
    live_sub: "Потокові дані з вашого ринкового API",
    live_loading: "Підключення до потоку даних...",
    live_pair: "Пара",
    live_tf: "Таймфрейм",
    live_note: "Дані оновлюються в реальному часі з приватного API. Свічка формується наживо.",
    live_live: "НАЖИВО",

    sig_title: "Signals",
    sig_sub: "Оберіть пару та тип угоди",
    sig_pair: "Валютна пара",
    sig_type: "Тип угоди",
    sig_cta: "Отримати сигнал",
    sig_note: "Один запит — один бінарний сигнал з напрямком, експірацією та точкою входу",
    sig_pair_group_forex: "Форекс",
    sig_pair_group_otc: "OTC",
    sig_error: "Не вдалося отримати сигнал. Спробуйте ще раз.",
    sig_error_trial_limit: "Ліміт пробного періоду для цього таймфрейму вичерпано (5 сигналів). Перейдіть на повний доступ, щоб продовжити.",


    sig_field_timeframe: "Таймфрейм",
    sig_field_strength: "Сила сигналу",
    sig_field_price: "Ціна входу",
    sig_field_entry: "Умова входу",
    sig_field_comment: "Аналіз ринку",
    sig_direction_up: "ВГОРУ (BUY)",
    sig_direction_down: "ВНИЗ (SELL)",
    sig_wait_title: "Сигнал сформовано",
    sig_wait_sub: "Використовуйте розраховані точки для відкриття ордера на своїй платформі",
    sig_choose_result: "Фіксація результату угоди",
    sig_btn_profit: "Угода в плюс",
    sig_btn_loss: "Угода в мінус",
    sig_btn_no_trade: "Не входив у угоду",
    sig_result_error: "Не вдалося зберегти результат. Спробуйте ще раз.",
    sig_copied: "Скопійовано!",
    sig_copy: "Копіювати",
    sig_active_badge: "Активний сигнал",
    sig_view_details: "Переглянути сетап",
    sig_close_modal: "Згорнути",
    sig_active_warning: "У вас вже є відкритий сигнал. Зафіксуйте результат або скасуйте його, щоб отримати новий.",
    sig_active_must_close: "Поточний сигнал активний",
    sig_btn_record_result: "Зафіксувати результат",

    scan_title: "Scanner",
    scan_sub: "Надішліть фото графіка — отримайте сигнал",
    scan_upload: "Завантажити фото графіка",
    scan_hint: "PNG, JPG — знімок екрана з платформи",
    scan_cta: "Проаналізувати",
    scan_analyzing: "Аналізуємо фото...",
    scan_error: "Не вдалося проаналізувати фото. Спробуйте ще раз.",
    scan_error_trial_limit: "Ліміт пробного періоду для сканера вичерпано (5 сканів). Перейдіть на повний доступ, щоб продовжити.",
    scan_change_photo: "Змінити фото",
    scan_result_title: "Скан",
    scan_file_hint_error: "Оберіть зображення (PNG або JPG).",
    scan_timeframe: "Таймфрейм",

    prof_title: "Профіль",
    prof_id: "POCKET ID",
    prof_id_baba: "BABAOPTION ID",
    prof_balance: "Баланс",
    prof_balance_show: "Показати баланс",
    prof_balance_hide: "Приховати баланс",
    prof_trial: "Пробний період",
    prof_trial_expired: "Період завершено",
    prof_trial_signals_left: "сигналів лишилось",
    prof_trial_scanner: "Сканер",
    prof_lang: "Мова інтерфейсу",
    prof_topup: "Поповнити",
    prof_stats: "Статистика",
    prof_winrate: "Вінрейт",
    prof_total_signals: "Сигналів отримано",
    prof_settings: "Налаштування",
    prof_vip_title: "VIP-доступ",
    prof_vip_desc: "Отримай персональні посилання на наш закритий VIP чат і канал.",
    prof_vip_trial_locked: "VIP-доступ недоступний під час пробного періоду. Він відкриється після його завершення.",
    prof_vip_generate: "Згенерувати",
    prof_vip_generating: "Генеруємо…",
    prof_vip_error: "Не вдалося отримати посилання. Спробуй ще раз.",
    prof_vip_refresh: "Оновити посилання",
    prof_vip_chat: "VIP чат",
    prof_vip_chat_sub: "Обговорення та спілкування з командою",
    prof_vip_channel: "VIP канал",
    prof_vip_channel_sub: "Новини та ексклюзивні матеріали",
    prof_history: "Історія сигналів",
    prof_history_sub: "Останні сигнали ботів і їх результати",
    prof_filter_all: "Усі",
    prof_filter_win: "Прибуткові",
    prof_filter_loss: "Збиткові",
    prof_filter_source_all: "Усі боти",
    prof_filter_signals: "Signals",
    prof_filter_scanner: "Scanner",
    prof_filter_date_all: "Всі дні",
    prof_filter_date_clear: "Скинути дату",
    prof_result_win: "Прибуток",
    prof_result_loss: "Збиток",
    prof_today: "Сьогодні",
    prof_yesterday: "Вчора",
    prof_history_empty: "Тут поки що порожньо — сигналів ще не було.",
    prof_history_empty_filtered: "За цими фільтрами сигналів не знайдено.",

    prof_section_balance: "Баланс",
    prof_section_stats: "Статистика",
    prof_section_vip: "VIP-доступ",
    prof_section_account: "Керування акаунтом",
    prof_section_history: "Історія сигналів",

    prof_security_title: "Керування акаунтом",
    prof_tg_link_title: "Привʼязати Telegram",
    prof_tg_linked_title: "Telegram привʼязано",
    prof_tg_link_sub: "Отримуйте сигнали через бота",
    prof_tg_linked_sub: "Підключено",
    prof_tg_link_error: "Помилка. Спробуйте ще раз",
    prof_email_linked_title: "Електронна пошта",
    prof_email_link_title: "Привʼязати пошту",
    prof_email_link_sub: "Додайте пошту для входу з браузера",
    prof_email_placeholder: "Введіть email",
    prof_email_error: "Не вдалося привʼязати пошту. Спробуйте ще раз.",
    prof_email_taken: "Ця електронна пошта вже використовується іншим акаунтом.",
    prof_email_success: "Пошту успішно привʼязано!",
    prof_email_submit: "Привʼязати пошту",
    prof_pw_change_title: "Змінити пароль",
    prof_pw_set_title: "Встановити пароль",
    prof_pw_change_sub: "Оновіть пароль для безпеки",
    prof_pw_set_sub: "Захистіть акаунт паролем",
    prof_pw_current_placeholder: "Поточний пароль",
    prof_pw_new_placeholder: "Новий пароль (мін. 8 символів)",
    prof_pw_confirm_placeholder: "Підтвердити пароль",
    prof_pw_mismatch: "Паролі не співпадають",
    prof_pw_wrong_current: "Невірний поточний пароль",
    prof_pw_error_generic: "Помилка. Спробуйте ще раз",
    prof_pw_success: "Пароль оновлено!",
    prof_pw_change_submit: "Зберегти",
    prof_pw_set_submit: "Встановити",
    prof_status_active: "Активний",
    prof_status_not_set: "Не встановлено",
    prof_logout: "Вийти",

    locked_title: "Розділ заблокований",
    locked_access_desc: "Доступ до цього розділу закритий для вашого акаунта. Зверніться до підтримки, якщо вважаєте це помилкою.",
    locked_balance_desc: "Поповніть баланс, щоб розблокувати цей розділ. Мінімальний баланс для доступу — 10 USD.",
    locked_topup: "Поповнити баланс",
    locked_trial_expired_desc: "Пробний період закінчився. Щоб продовжити користуватися сервісом, зверніться до менеджера та прив’яжіть POCKET ID.",
    locked_trial_renew_button: "Зареєструватися по рефералці",
    trial_renew_error: "Не вдалося прив'язати ID. Перевірте і спробуйте ще раз.",
    trial_renew_success_title: "Заявку відправлено",
    trial_renew_success_desc: "Ваш ID отримано. Доступ буде відновлено найближчим часом.",
    locked_trial_profile: "Відкрити профіль",
    locked_trial_manager: "Написати менеджеру",

    copytrade_title: "Копітрейдинг",
    copytrade_sub: "Підключіться до копіювання угод на Pocket Option",
    copytrade_id_label: "ID для копітрейдингу",
    copytrade_copy: "Копіювати",
    copytrade_copied: "Скопійовано",
    copytrade_steps_title: "Як підключитись",
    copytrade_step1_t: "Скопіюйте ID",
    copytrade_step1_d: "Натисніть кнопку «Копіювати» поруч з ID — він буде збережений у буфер обміну.",
    copytrade_step2_t: "Відкрийте Pocket Option",
    copytrade_step2_d: "Перейдіть до розділу «Соціальна торгівля» у застосунку або на сайті.",
    copytrade_step3_t: "Вставте ID у пошук",
    copytrade_step3_d: "Вставте скопійований ID у рядок пошуку та відкрийте профіль трейдера.",
    copytrade_step4_t: "Натисніть «Копіювати»",
    copytrade_step4_d: "Налаштуйте параметри копіювання та підтвердьте підключення — угоди будуть копіюватися автоматично.",
    copytrade_screenshot_title: "Приклад налаштувань",
    copytrade_screenshot_alt: "Скріншот налаштувань копітрейдингу в Pocket Option",
    copytrade_screenshot_zoom_hint: "Натисніть, щоб збільшити",
    copytrade_screenshot_close: "Закрити",

    restricted_title: "Акаунт обмежено",
    restricted_desc: "Ваш акаунт обмежено адміністратором. Зверніться в підтримку для уточнення деталей.",
    restricted_support: "Звернутись у підтримку",
    maintenance_title: "Технічні роботи",
    maintenance_desc: "Ми оновлюємо застосунок. Повернемося до роботи зовсім скоро.",
    maintenance_timer: "Орієнтовний час до відновлення",
  },
  ru: {
    nav_copytrade: "Копитрейдинг",
    nav_menu_open: "Открыть меню",
    nav_menu_close: "Закрыть меню",
    nav_status_online: "в сети",
    nav_edu: "Обучение",
    nav_signals: "Signals",
    nav_scanner: "Scanner",
    nav_profile: "Профиль",

    reg_title: "Введи ID аккаунта",
    reg_desc: "Если ID не найден, зарегистрируйтесь по ссылке и пополните счёт.",
    reg_register: "Зарегистрироваться",
    reg_have_account: "Уже есть аккаунт",
    reg_id_label: "ID аккаунта",
    reg_id_hint: "Только цифры, например 12345678",
    reg_id_hint_pocket: "Только цифры, например 12345678",
    reg_id_placeholder: "Введи ID аккаунта",
    reg_verify: "Проверить ID",
    reg_error: "ID не найден. Проверьте и попробуйте снова.",
    reg_support: "Обратиться в поддержку",
    reg_closed_title: "Регистрация временно отключена",
    reg_closed_desc: "Регистрация сейчас отключена. Следите за новостями или обратитесь в поддержку.",
    reg_switch_title: "Уже есть аккаунт Pocket Option?",
    reg_switch_desc1: "Чтобы попасть в нашу команду, нужно отобразиться в нашей системе. Для этого создайте новый аккаунт строго по нашей ссылке.",
    reg_switch_desc2: "Если на старом аккаунте есть средства, их нужно просто вывести.",
    reg_switch_desc3: "Торговать вы будете уже с нового аккаунта, созданного по нашей ссылке.",
    reg_switch_step1: "Выйди из текущего аккаунта в Pocket Option.",
    reg_switch_step2: "Закрой все вкладки с Pocket Option.",
    reg_switch_step3: "Перейди по нашей ссылке.",
    reg_switch_step4: "Зарегистрируй новый аккаунт.",
    reg_switch_step5: "Почту вводи от руки, а не через быструю регистрацию.",
    reg_switch_note: "Сделай всё строго в точности по порядку.",
    reg_switch_link: "Перейти по ссылке",
    reg_link_alt_ru: "Ссылка не открывается? Попробуйте зеркало для РФ",
    reg_link_alt_main: "Не из России? Открыть основную ссылку",
    reg_switch_back: "Назад",
    reg_test_code_link: "Использовать тестовый код",
    reg_test_code_title: "Тестовый доступ",
    reg_test_code_desc: "Введи 6-значный код (буквы и цифры), который ты получил для тестирования приложения.",
    reg_test_code_label: "Тестовый код",
    reg_test_code_placeholder: "Например: A1B2C9",
    reg_test_code_hint: "6 символов: латинские буквы и цифры",
    reg_test_code_verify: "Активировать код",
    reg_test_code_error: "Неверный или просроченный код. Проверь и попробуй снова.",
    reg_test_code_back: "Назад",
    reg_trial_link: "Пробный период",
    reg_trial_title: "Пробный период",
    reg_trial_desc: "Бесплатный пробный период без кода: 5 сигналов на каждый таймфрейм.",
    reg_trial_verify: "Активировать пробный период",
    reg_trial_error: "Не удалось активировать пробный период. Попробуй ещё раз.",
    reg_trial_taken: "Пробный период для этого аккаунта уже был активирован ранее.",
    reg_trial_back: "Назад",
    auth_loading: "Проверяем аккаунт…",
    auth_tab_login: "Вход",
    auth_tab_signup: "Регистрация",
    auth_login_title: "С возвращением",
    auth_login_desc: "Войдите с помощью почты и пароля.",
    auth_signup_title: "Создать аккаунт",
    auth_signup_desc: "Укажите почту, пароль и ID вашего аккаунта Pocket Option.",
    auth_login_placeholder: "Электронная почта",
    auth_password_placeholder: "Пароль",
    auth_fullname_placeholder: "Имя и фамилия (необязательно)",
    auth_email_invalid: "Введите корректную электронную почту.",
    auth_error_not_found: "Неверная почта или пароль.",
    auth_error_login_taken: "Эта почта уже зарегистрирована. Попробуйте войти.",
    auth_error_password_short: "Пароль должен содержать не менее 8 символов.",
    auth_error_generic: "Что-то пошло не так. Попробуйте ещё раз.",
    auth_login_submit: "Войти",
    auth_signup_submit: "Зарегистрироваться",

    edu_title: "Обучение трейдингу",
    edu_sub: "Курсы от основ до практики",
    edu_continue: "Продолжить",
    edu_locked: "Закрыто",
    course1_t: "Основы рынка",
    course1_d: "Свечи, тренд, поддержка/сопротивление",
    course2_t: "Управление риском",
    course2_d: "Размер сделки, стоп, депозит",
    course3_t: "Паттерны разворота",
    course3_d: "Формации для входу в сделку",
    edu_about: "О курсе",
    edu_program: "Программа курса",
    edu_min: "мин.",
    edu_lesson_word: "уроки",
    edu_loading: "Загрузка курсов...",
    edu_error: "Не удалось загрузить курсы. Попробуйте ещё раз.",
    edu_retry: "Попробовать ещё раз",
    edu_empty: "Пока нет доступных курсов.",
    edu_lesson_fallback: "Урок",
    edu_hour: "ч",
    lesson_loading: "Загрузка урока...",
    lesson_error: "Не удалось загрузить урок. Попробуйте ещё раз.",
    lesson_protected_hint: "Материал доступен только для просмотра — без скачивания и копирования",
    edu_video_title: "Видео урока",
    lesson_devtools_warning: "Контент скрыт, пока открыты инструменты разработчика",

    nav_live: "Live Charts",
    live_title: "Live Charts",
    live_sub: "Потоковые данные с вашего рыночного API",
    live_loading: "Подключение к потоку данных...",
    live_pair: "Пара",
    live_tf: "Таймфрейм",
    live_note: "Данные обновляются в реальном времени из приватного API. Свеча формируется вживую.",
    live_live: "ОНЛАЙН",

    sig_title: "Signals",
    sig_sub: "Выберите пару и тип сделки",
    sig_pair: "Валютная пара",
    sig_type: "Тип сделки",
    sig_cta: "Получить сигнал",
    sig_note: "Один запрос — один бинарный сигнал с направлением, экспирацией и точкой входа",
    sig_pair_group_forex: "Форекс",
    sig_pair_group_otc: "OTC",
    sig_error: "Не удалось получить сигнал. Попробуйте ещё раз.",
    sig_error_trial_limit: "Лимит пробного периода для этого таймфрейма исчерпан (5 сигналов). Перейдите на полный доступ, чтобы продолжить.",


    sig_field_timeframe: "Таймфрейм",
    sig_field_strength: "Сила сигнала",
    sig_field_price: "Цена входа",
    sig_field_entry: "Условие входа",
    sig_field_comment: "Анализ рынка",
    sig_direction_up: "ВВЕРХ (BUY)",
    sig_direction_down: "ВНИЗ (SELL)",
    sig_wait_title: "Сигнал сформирован",
    sig_wait_sub: "Используйте рассчитанные точки для открытия ордера на своей платформе",
    sig_choose_result: "Фиксация результата сделки",
    sig_btn_profit: "Сделка в плюс",
    sig_btn_loss: "Сделка в минус",
    sig_btn_no_trade: "Не входил в сделку",
    sig_result_error: "Не удалось сохранить результат. Попробуйте ещё раз.",
    sig_copied: "Скопировано!",
    sig_copy: "Копировать",
    sig_active_badge: "Активный сигнал",
    sig_view_details: "Посмотреть сетап",
    sig_close_modal: "Свернуть",
    sig_active_warning: "У вас уже есть открытый сигнал. Зафиксируйте результат или отмените его, чтобы получить новый.",
    sig_active_must_close: "Текущий сигнал активен",
    sig_btn_record_result: "Зафиксировать результат",

    scan_title: "Scanner",
    scan_sub: "Отправьте фото графика — получите сигнал",
    scan_upload: "Загрузить фото графика",
    scan_hint: "PNG, JPG — скриншот с платформы",
    scan_cta: "Проанализировать",
    scan_analyzing: "Анализируем фото...",
    scan_error: "Не удалось проанализировать фото. Попробуйте ещё раз.",
    scan_error_trial_limit: "Лимит пробного периода для сканера исчерпан (5 сканов). Перейдите на полный доступ, чтобы продолжить.",
    scan_change_photo: "Изменить фото",
    scan_result_title: "Скан",
    scan_file_hint_error: "Выберите изображение (PNG или JPG).",
    scan_timeframe: "Таймфрейм",

    prof_title: "Профиль",
    prof_id: "POCKET ID",
    prof_id_baba: "BABAOPTION ID",
    prof_balance: "Баланс",
    prof_balance_show: "Показать баланс",
    prof_balance_hide: "Скрыть баланс",
    prof_trial: "Пробный период",
    prof_trial_expired: "Период завершён",
    prof_trial_signals_left: "сигналов осталось",
    prof_trial_scanner: "Сканер",
    prof_lang: "Язык интерфейса",
    prof_topup: "Пополнить",
    prof_stats: "Статистика",
    prof_winrate: "Винрейт",
    prof_total_signals: "Получено сигналов",
    prof_settings: "Настройки",
    prof_vip_title: "VIP-доступ",
    prof_vip_desc: "Получи персональные ссылки на наш закрытый VIP чат и канал.",
    prof_vip_trial_locked: "VIP-доступ недоступен во время пробного периода. Он откроется после его завершения.",
    prof_vip_generate: "Сгенерировать",
    prof_vip_generating: "Генерируем…",
    prof_vip_error: "Не удалось получить ссылки. Попробуйте ещё раз.",
    prof_vip_refresh: "Обновить ссылки",
    prof_vip_chat: "VIP чат",
    prof_vip_chat_sub: "Обсуждения и общение с командой",
    prof_vip_channel: "VIP канал",
    prof_vip_channel_sub: "Новости и эксклюзивные материалы",
    prof_history: "История сигналов",
    prof_history_sub: "Последние сигналы ботов и их результаты",
    prof_filter_all: "Все",
    prof_filter_win: "Прибыльные",
    prof_filter_loss: "Убыточные",
    prof_filter_source_all: "Все боты",
    prof_filter_signals: "Signals",
    prof_filter_scanner: "Scanner",
    prof_filter_date_all: "Все дни",
    prof_filter_date_clear: "Сбросить дату",
    prof_result_win: "Прибыль",
    prof_result_loss: "Убыток",
    prof_today: "Сегодня",
    prof_yesterday: "Вчера",
    prof_history_empty: "Здесь пока пусто — сигналов ещё не было.",
    prof_history_empty_filtered: "По этим фильтрам сигналов не найдено.",

    prof_section_balance: "Баланс",
    prof_section_stats: "Статистика",
    prof_section_vip: "VIP-доступ",
    prof_section_account: "Управление аккаунтом",
    prof_section_history: "История сигналов",

    prof_security_title: "Управление аккаунтом",
    prof_tg_link_title: "Привязать Telegram",
    prof_tg_linked_title: "Telegram привязан",
    prof_tg_link_sub: "Получайте сигналы через бота",
    prof_tg_linked_sub: "Подключено",
    prof_tg_link_error: "Ошибка. Попробуйте ещё раз",
    prof_email_linked_title: "Электронная почта",
    prof_email_link_title: "Привязать почту",
    prof_email_link_sub: "Добавьте почту для входа из браузера",
    prof_email_placeholder: "Введите email",
    prof_email_error: "Не удалось привязать почту. Попробуйте ещё раз.",
    prof_email_taken: "Эта почта уже используется другим аккаунтом.",
    prof_email_success: "Почта успешно привязана!",
    prof_email_submit: "Привязать почту",
    prof_pw_change_title: "Изменить пароль",
    prof_pw_set_title: "Установить пароль",
    prof_pw_change_sub: "Обновите пароль для безопасности",
    prof_pw_set_sub: "Защитите аккаунт паролем",
    prof_pw_current_placeholder: "Текущий пароль",
    prof_pw_new_placeholder: "Новый пароль (мин. 8 символов)",
    prof_pw_confirm_placeholder: "Подтвердить пароль",
    prof_pw_mismatch: "Пароли не совпадают",
    prof_pw_wrong_current: "Неверный текущий пароль",
    prof_pw_error_generic: "Ошибка. Попробуйте ещё раз",
    prof_pw_success: "Пароль обновлён!",
    prof_pw_change_submit: "Сохранить",
    prof_pw_set_submit: "Установить",
    prof_status_active: "Активен",
    prof_status_not_set: "Не установлен",
    prof_logout: "Выйти",

    locked_title: "Раздел заблокирован",
    locked_access_desc: "Доступ к этому разделу закрыт для вашего аккаунта. Обратитесь в поддержку, если считаете это ошибкой.",
    locked_balance_desc: "Пополните баланс, чтобы разблокировать этот раздел. Минимальный баланс для доступа — 10 USD.",
    locked_topup: "Пополнить баланс",
    locked_trial_expired_desc: "Пробный период закончился. Чтобы продолжить пользоваться сервисом, обратитесь к менеджеру и привяжите POCKET ID.",
    locked_trial_renew_button: "Зарегистрироваться по рефералке",
    trial_renew_error: "Не удалось привязать ID. Проверьте и попробуйте снова.",
    trial_renew_success_title: "Заявка отправлена",
    trial_renew_success_desc: "Ваш ID получен. Доступ будет восстановлен в ближайшее время.",
    locked_trial_profile: "Открыть профиль",
    locked_trial_manager: "Написать менеджеру",

    copytrade_title: "Копитрейдинг",
    copytrade_sub: "Подключитесь к копированию сделок на Pocket Option",
    copytrade_id_label: "ID для копитрейдинга",
    copytrade_copy: "Копировать",
    copytrade_copied: "Скопировано",
    copytrade_steps_title: "Как подключиться",
    copytrade_step1_t: "Скопируйте ID",
    copytrade_step1_d: "Нажмите кнопку «Копировать» рядом с ID — он сохранится в буфер обмена.",
    copytrade_step2_t: "Откройте Pocket Option",
    copytrade_step2_d: "Перейдите в раздел «Социальная торговля» в приложении или на сайте.",
    copytrade_step3_t: "Вставьте ID в поиск",
    copytrade_step3_d: "Вставьте скопированный ID в строку поиска и откройте профиль трейдера.",
    copytrade_step4_t: "Нажмите «Копировать»",
    copytrade_step4_d: "Настройте параметры копирования и подтвердите подключение — сделки будут копироваться автоматически.",
    copytrade_screenshot_title: "Пример настроек",
    copytrade_screenshot_alt: "Скриншот настроек копитрейдинга в Pocket Option",
    copytrade_screenshot_zoom_hint: "Нажмите, чтобы увеличить",
    copytrade_screenshot_close: "Закрыть",

    restricted_title: "Аккаунт ограничен",
    restricted_desc: "Ваш аккаунт ограничен администратором. Обратитесь в поддержку для уточнения деталей.",
    restricted_support: "Обратиться в поддержку",
    maintenance_title: "Технические работы",
    maintenance_desc: "Мы обновляем приложение. Вернёмся к работе совсем скоро.",
    maintenance_timer: "Ориентировочное время до восстановления",
  },
  en: {
    nav_copytrade: "Copy Trading",
    nav_menu_open: "Open menu",
    nav_menu_close: "Close menu",
    nav_status_online: "online",
    nav_edu: "Education",
    nav_signals: "Signals",
    nav_scanner: "Scanner",
    nav_profile: "Profile",

    reg_title: "Enter account ID",
    reg_desc: "If your ID isn't found, register via the link and top up your balance.",
    reg_register: "Register",
    reg_have_account: "I already have an account",
    reg_id_label: "Account ID",
    reg_id_hint: "Digits only, e.g. 12345678",
    reg_id_hint_pocket: "Digits only, e.g. 12345678",
    reg_id_placeholder: "Enter account ID",
    reg_verify: "Verify ID",
    reg_error: "ID not found. Check it and try again.",
    reg_support: "Contact support",
    reg_closed_title: "Registration temporarily closed",
    reg_closed_desc: "Registration is currently disabled. Stay tuned for updates or contact support.",
    reg_switch_title: "Already have a Pocket Option account?",
    reg_switch_desc1: "To join our team, you need to show up in our system. To do this, create a new account strictly via our link.",
    reg_switch_desc2: "If your old account has funds, just withdraw them.",
    reg_switch_desc3: "You'll trade from the new account, created via our link.",
    reg_switch_step1: "Log out of your current Pocket Option account.",
    reg_switch_step2: "Close all Pocket Option tabs.",
    reg_switch_step3: "Follow our link.",
    reg_switch_step4: "Register a new account.",
    reg_switch_step5: "Type your email by hand, not via quick sign-up.",
    reg_switch_note: "Follow every step exactly in order.",
    reg_switch_link: "Follow the link",
    reg_link_alt_ru: "Link not opening? Try the Russia mirror",
    reg_link_alt_main: "Not in Russia? Open the main link",
    reg_switch_back: "Back",
    reg_test_code_link: "Use a test code",
    reg_test_code_title: "Test access",
    reg_test_code_desc: "Enter the 6-character code (letters and digits) you received to test the app.",
    reg_test_code_label: "Test code",
    reg_test_code_placeholder: "e.g. A1B2C9",
    reg_test_code_hint: "6 characters: letters and digits",
    reg_test_code_verify: "Activate code",
    reg_test_code_error: "Invalid or expired code. Check it and try again.",
    reg_test_code_back: "Back",
    reg_trial_link: "Trial period",
    reg_trial_title: "Trial period",
    reg_trial_desc: "Free trial, no code needed: 5 signals per timeframe.",
    reg_trial_verify: "Activate trial period",
    reg_trial_error: "Couldn't activate the trial period. Please try again.",
    reg_trial_taken: "A trial has already been activated for this account.",
    reg_trial_back: "Back",
    auth_loading: "Checking your account…",
    auth_tab_login: "Log in",
    auth_tab_signup: "Sign up",
    auth_login_title: "Welcome back",
    auth_login_desc: "Log in with your email and password.",
    auth_signup_title: "Create an account",
    auth_signup_desc: "Enter your email, password, and your Pocket Option account ID.",
    auth_login_placeholder: "Email address",
    auth_password_placeholder: "Password",
    auth_fullname_placeholder: "Full name (optional)",
    auth_email_invalid: "Enter a valid email address.",
    auth_error_not_found: "Incorrect email or password.",
    auth_error_login_taken: "This email is already registered. Try logging in.",
    auth_error_password_short: "Password must be at least 8 characters.",
    auth_error_generic: "Something went wrong. Please try again.",
    auth_login_submit: "Log in",
    auth_signup_submit: "Sign up",

    edu_title: "Trading education",
    edu_sub: "Courses from basics to practice",
    edu_continue: "Continue",
    edu_locked: "Locked",
    course1_t: "Market basics",
    course1_d: "Candles, trend, support/resistance",
    course2_t: "Risk management",
    course2_d: "Position size, stop-loss, deposit",
    course3_t: "Reversal patterns",
    course3_d: "Formations for entry timing",
    edu_about: "About course",
    edu_program: "Course program",
    edu_min: "min",
    edu_lesson_word: "lessons",
    edu_loading: "Loading courses...",
    edu_error: "Could not load the courses. Please try again.",
    edu_retry: "Try again",
    edu_empty: "No courses available yet.",
    edu_lesson_fallback: "Lesson",
    edu_hour: "h",
    lesson_loading: "Loading lesson...",
    lesson_error: "Could not load the lesson. Please try again.",
    lesson_protected_hint: "View-only material — no download or copying",
    edu_video_title: "Lesson video",
    lesson_devtools_warning: "Content hidden while developer tools are open",

    nav_live: "Live Charts",
    live_title: "Live Charts",
    live_sub: "Streaming data from your market API",
    live_loading: "Connecting to the data stream...",
    live_pair: "Pair",
    live_tf: "Timeframe",
    live_note: "Data updates in real time from the private API. The candle forms live.",
    live_live: "LIVE",

    sig_title: "Signals",
    sig_sub: "Choose a pair and deal type",
    sig_pair: "Currency pair",
    sig_type: "Deal type",
    sig_cta: "Get signal",
    sig_note: "One request — one binary signal with a direction, expiry and entry price",
    sig_pair_group_forex: "Forex",
    sig_pair_group_otc: "OTC",
    sig_error: "Couldn't get a signal. Please try again.",
    sig_error_trial_limit: "Trial limit reached for this timeframe (5 signals). Upgrade to full access to continue.",


    sig_field_timeframe: "Timeframe",
    sig_field_strength: "Signal strength",
    sig_field_price: "Entry price",
    sig_field_risk_reward: "Risk / Reward",
    sig_field_entry: "Entry condition",
    sig_field_comment: "Market analysis",
    sig_direction_up: "UP (BUY)",
    sig_direction_down: "DOWN (SELL)",
    sig_wait_title: "Signal generated",
    sig_wait_sub: "Use the direction and expiry to place a binary option on your trading platform",
    sig_choose_result: "Record trade outcome",
    sig_btn_profit: "Trade in profit",
    sig_btn_loss: "Trade at a loss",
    sig_btn_no_trade: "Didn’t enter the trade",
    sig_result_error: "Couldn't save the result. Please try again.",
    sig_copied: "Copied!",
    sig_copy: "Copy",
    sig_active_badge: "Active signal",
    sig_view_details: "View signal details",
    sig_close_modal: "Minimize",
    sig_active_warning: "You already have an active signal. Record the outcome or cancel it to get a new one.",
    sig_active_must_close: "Current signal is active",
    sig_btn_record_result: "Record result",

    scan_title: "Scanner",
    scan_sub: "Send a chart photo — get a signal",
    scan_upload: "Upload chart photo",
    scan_hint: "PNG, JPG — a screenshot from your platform",
    scan_cta: "Analyze",
    scan_analyzing: "Analyzing photo...",
    scan_error: "Could not analyze the photo. Please try again.",
    scan_error_trial_limit: "Trial limit reached for the scanner (5 scans). Upgrade to full access to continue.",
    scan_change_photo: "Change photo",
    scan_result_title: "Scan",
    scan_file_hint_error: "Please choose an image (PNG or JPG).",
    scan_timeframe: "Timeframe",

    prof_title: "Profile",
    prof_id: "POCKET ID",
    prof_id_baba: "BABAOPTION ID",
    prof_balance: "Balance",
    prof_balance_show: "Show balance",
    prof_balance_hide: "Hide balance",
    prof_trial: "Trial period",
    prof_trial_expired: "Trial ended",
    prof_trial_signals_left: "signals left",
    prof_trial_scanner: "Scanner",
    prof_lang: "Interface language",
    prof_topup: "Top up",
    prof_stats: "Stats",
    prof_winrate: "Win rate",
    prof_total_signals: "Signals received",
    prof_settings: "Settings",
    prof_vip_title: "VIP access",
    prof_vip_desc: "Get your personal links to our private VIP chat and channel.",
    prof_vip_trial_locked: "VIP access isn't available during the trial period. It unlocks once your trial ends.",
    prof_vip_generate: "Generate",
    prof_vip_generating: "Generating…",
    prof_vip_error: "Couldn't fetch the links. Try again.",
    prof_vip_refresh: "Refresh links",
    prof_vip_chat: "VIP chat",
    prof_vip_chat_sub: "Discussions and chatting with the team",
    prof_vip_channel: "VIP channel",
    prof_vip_channel_sub: "News and exclusive materials",
    prof_history: "Signal history",
    prof_history_sub: "Recent bot signals and their results",
    prof_filter_all: "All",
    prof_filter_win: "Wins",
    prof_filter_loss: "Losses",
    prof_filter_source_all: "All bots",
    prof_filter_signals: "Signals",
    prof_filter_scanner: "Scanner",
    prof_filter_date_all: "All days",
    prof_filter_date_clear: "Clear date",
    prof_result_win: "Profit",
    prof_result_loss: "Loss",
    prof_today: "Today",
    prof_yesterday: "Yesterday",
    prof_history_empty: "It's empty here for now — no signals yet.",
    prof_history_empty_filtered: "No signals found for these filters.",

    prof_section_balance: "Balance",
    prof_section_stats: "Statistics",
    prof_section_vip: "VIP access",
    prof_section_account: "Account management",
    prof_section_history: "Signal history",

    prof_security_title: "Account management",
    prof_tg_link_title: "Link Telegram",
    prof_tg_linked_title: "Telegram linked",
    prof_tg_link_sub: "Receive signals via bot",
    prof_tg_linked_sub: "Connected",
    prof_tg_link_error: "Error. Try again",
    prof_email_linked_title: "Email address",
    prof_email_link_title: "Link Email",
    prof_email_link_sub: "Add email to log in from a browser",
    prof_email_placeholder: "Enter email",
    prof_email_error: "Failed to link email. Try again.",
    prof_email_taken: "This email is already in use by another account.",
    prof_email_success: "Email linked successfully!",
    prof_email_submit: "Link Email",
    prof_pw_change_title: "Change password",
    prof_pw_set_title: "Set password",
    prof_pw_change_sub: "Update your password for security",
    prof_pw_set_sub: "Protect your account with a password",
    prof_pw_current_placeholder: "Current password",
    prof_pw_new_placeholder: "New password (min. 8 characters)",
    prof_pw_confirm_placeholder: "Confirm password",
    prof_pw_mismatch: "Passwords don't match",
    prof_pw_wrong_current: "Wrong current password",
    prof_pw_error_generic: "Error. Try again",
    prof_pw_success: "Password updated!",
    prof_pw_change_submit: "Save",
    prof_pw_set_submit: "Set",
    prof_status_active: "Active",
    prof_status_not_set: "Not set",
    prof_logout: "Log out",

    locked_title: "Section locked",
    locked_access_desc: "This section isn't available for your account. Contact support if you think this is a mistake.",
    locked_balance_desc: "Top up your balance to unlock this section. Minimum balance for access is 10 USD.",
    locked_topup: "Top up balance",
    locked_trial_expired_desc: "Your trial period has ended. To continue using the service, contact the manager and link your POCKET ID.",
    locked_trial_renew_button: "Register via referral link",
    trial_renew_error: "Couldn't link that ID. Check it and try again.",
    trial_renew_success_title: "Request sent",
    trial_renew_success_desc: "Your ID has been received. Access will be restored shortly.",
    locked_trial_profile: "Open profile",
    locked_trial_manager: "Contact manager",

    copytrade_title: "Copy Trading",
    copytrade_sub: "Connect to trade copying on Pocket Option",
    copytrade_id_label: "Copy trading ID",
    copytrade_copy: "Copy",
    copytrade_copied: "Copied",
    copytrade_steps_title: "How to connect",
    copytrade_step1_t: "Copy the ID",
    copytrade_step1_d: "Click the “Copy” button next to the ID — it will be saved to your clipboard.",
    copytrade_step2_t: "Open Pocket Option",
    copytrade_step2_d: "Go to the “Social Trading” section in the app or on the website.",
    copytrade_step3_t: "Paste the ID into search",
    copytrade_step3_d: "Paste the copied ID into the search bar and open the trader’s profile.",
    copytrade_step4_t: "Click “Copy”",
    copytrade_step4_d: "Set up the copy trading parameters and confirm the connection — trades will be copied automatically.",
    copytrade_screenshot_title: "Settings example",
    copytrade_screenshot_alt: "Screenshot of copy trading settings in Pocket Option",
    copytrade_screenshot_zoom_hint: "Tap to zoom in",
    copytrade_screenshot_close: "Close",

    restricted_title: "Account restricted",
    restricted_desc: "Your account has been restricted by the administrator. Contact support for details.",
    restricted_support: "Contact support",
  },
};